import {Cookies, LocalStorage} from '../utils/storages'
import {COOKIE_STORAGE_KEYS} from '../utils/constants'
import {useBasketStore, useCustomerStore} from '../store/hooks/useStore'

export const useSoftLogoutData = () => {
  const {clearSoftLogoutBasket} = useBasketStore()
  const {clearSoftLogoutWishlist} = useCustomerStore()

  const details = LocalStorage.available ? JSON.parse(
    LocalStorage.get(COOKIE_STORAGE_KEYS.REGISTERED_CUSTOMER_SOFT_LOGOUT_ACCOUNT_DETAILS) || '{}',
  ) : {}

  const postcode = LocalStorage.available ? LocalStorage.get(COOKIE_STORAGE_KEYS.REGISTERED_CUSTOMER_SOFT_LOGOUT_POSTCODE) ?? null : null

  const signOutEntirely = async () => {
    Cookies.remove(COOKIE_STORAGE_KEYS.DW_POSTALCODE)
    await clearSoftLogoutBasket()
    await clearSoftLogoutWishlist()
    Cookies.remove(COOKIE_STORAGE_KEYS.REGISTERED_CUSTOMER_SOFT_LOGOUT_ACCOUNT_DETAILS)
    Cookies.remove(COOKIE_STORAGE_KEYS.REGISTERED_CUSTOMER_SOFT_LOGOUT)
  }

  return {
    email: details?.login,
    phone: details?.phone,
    firstName: details?.firstName,
    softLogout: JSON.parse(
      Cookies.get(COOKIE_STORAGE_KEYS.REGISTERED_CUSTOMER_SOFT_LOGOUT) || 'false',
    ),
    customerNo: details?.customerNo,
    lastName: details?.lastName,
    addressBook: details?.addressBook,
    orderCount: details?.orderCount,
    legacyOrderCount: details?.legacyOrderCount,
    postcode,
    signOutEntirely,
  }
}
